// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ObMo","right":"styles_right__2tW5i"};